import React from 'react'
import PropTypes from 'prop-types'
import { ACTIVE, OBSOLETE } from 'utils/constants'
import { classNames } from 'utils/utils'

import ActiveButton from '../LifeCycleButtons/ActiveButton'

import withStyle, { PhaseConnector } from './ObsoleteFeature.style'
import { ObsoleteButton } from '../LifeCycleButtons'

const ObsoleteFeature = (props) => {
  const { currentStatus, className, setConfirmObsolete } = props
  const handleClick = () => {
    setConfirmObsolete(true)
  }

  const isActive = currentStatus === ACTIVE
  const isObselete = currentStatus === OBSOLETE

  return (
    <div className={classNames(className, 'life-cycle-editor')}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="188"
        height="52"
        viewBox="0 0 188 52"
      >
        <g fill="none" fillRule="evenodd">
          <PhaseConnector strokeLinecap="square" d="M90 17H37M112 17h-55" />
          <ActiveButton
            isSelected={isActive}
            transformX={8}
            transformY={4}
            labelTransform="translate(-150 6)"
          />
          <ObsoleteButton
            isSelected={isObselete}
            onClick={handleClick}
            isSelectable={isActive}
            transformX={85}
            transformY={4}
            labelTransform="translate(-78 6)"
          />
        </g>
      </svg>
    </div>
  )
}

ObsoleteFeature.propTypes = {
  className: PropTypes.string,
  currentStatus: PropTypes.oneOf([ACTIVE, OBSOLETE]),
  setConfirmObsolete: PropTypes.func,
}

export default withStyle(ObsoleteFeature)
